import { render } from "./BitcoinPuzzle.vue?vue&type=template&id=219dfaac&scoped=true"
import script from "./BitcoinPuzzle.vue?vue&type=script&lang=js"
export * from "./BitcoinPuzzle.vue?vue&type=script&lang=js"

import "./BitcoinPuzzle.vue?vue&type=style&index=0&id=219dfaac&scoped=true&lang=css"
import "./BitcoinPuzzle.vue?vue&type=style&index=1&id=219dfaac&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-219dfaac"]])

export default __exports__